export default __webpack_public_path__ + "static/media/recognition.ecfe0adb.svg";